var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { Card, Input, List, Space, Button, Empty, Dropdown, Menu, } from "antd";
import { PlusOutlined, ReloadOutlined, EllipsisOutlined, } from "@ant-design/icons";
var Search = Input.Search;
/**
 * 通用列表面板组件
 */
var GenericPanelList = function (_a) {
    var _b = _a.title, title = _b === void 0 ? "数据列表" : _b, _c = _a.listData, listData = _c === void 0 ? [] : _c, _d = _a.loading, loading = _d === void 0 ? false : _d, _e = _a.buttons, buttons = _e === void 0 ? [] : _e, onSelect = _a.onSelect, onAddClick = _a.onAddClick, onRefresh = _a.onRefresh, _f = _a.height, height = _f === void 0 ? "100%" : _f, _g = _a.showSearch, showSearch = _g === void 0 ? true : _g, selectedId = _a.selectedId, _h = _a.menuItems, menuItems = _h === void 0 ? [] : _h, // 默认为空数组
    onMenuClick = _a.onMenuClick;
    // 状态定义
    var _j = useState(""), searchValue = _j[0], setSearchValue = _j[1];
    var _k = useState(listData), filteredListData = _k[0], setFilteredListData = _k[1];
    // 当原始列表数据变化时，更新过滤后的列表数据
    useEffect(function () {
        if (searchValue) {
            filterList(searchValue);
        }
        else {
            setFilteredListData(listData);
        }
    }, [listData]);
    // 处理搜索
    var handleSearch = function (value) {
        setSearchValue(value);
        if (value) {
            filterList(value);
        }
        else {
            setFilteredListData(listData);
        }
    };
    // 过滤列表数据
    var filterList = function (value) {
        var filtered = listData.filter(function (item) {
            return item.leftContent.toLowerCase().includes(value.toLowerCase());
        });
        setFilteredListData(filtered);
    };
    // 构建默认按钮
    var defaultButtons = [];
    // 添加刷新按钮
    if (onRefresh) {
        defaultButtons.push(_jsx(Button, __assign({ type: "link", icon: _jsx(ReloadOutlined, {}), onClick: onRefresh, style: {
                fontSize: "14px",
                padding: "0 8px",
            } }, { children: "\u5237\u65B0" }), "refresh"));
    }
    // 添加新增按钮
    if (onAddClick) {
        defaultButtons.push(_jsx(Button, __assign({ type: "link", icon: _jsx(PlusOutlined, {}), onClick: onAddClick, style: {
                fontSize: "14px",
                padding: "0 8px",
            } }, { children: "\u6DFB\u52A0" }), "add"));
    }
    // 合并默认按钮和自定义按钮
    var allButtons = __spreadArray(__spreadArray([], defaultButtons, true), buttons, true);
    // 从标签或其他React元素中提取数字
    var extractNumberFromContent = function (content) {
        // 如果已经是数字或字符串，直接返回
        if (typeof content === "number")
            return content.toString();
        if (typeof content === "string")
            return content;
        // 处理React元素
        if (React.isValidElement(content)) {
            // 如果是Tag组件，尝试从children中提取
            var children = content.props.children;
            if (children) {
                // 如果children是字符串，提取数字部分
                if (typeof children === "string") {
                    var match = children.match(/(\d+)/);
                    return match ? match[1] : "0";
                }
                // 如果children是数字
                if (typeof children === "number") {
                    return children.toString();
                }
            }
        }
        // 默认返回0
        return "0";
    };
    // 渲染菜单图标及下拉菜单
    var renderItemMenu = function (item) {
        var menu = (_jsx(Menu, __assign({ onClick: function (_a) {
                var key = _a.key;
                return onMenuClick && onMenuClick(item, key);
            } }, { children: menuItems.map(function (menuItem) { return (_jsx(Menu.Item, { children: menuItem.label }, menuItem.key)); }) })));
        return (_jsx(Dropdown, __assign({ overlay: menu, trigger: ["click"] }, { children: _jsx(Button, { type: "text", icon: _jsx(EllipsisOutlined, {}), size: "small", onClick: function (e) { return e.stopPropagation(); }, style: {
                    marginLeft: "auto",
                    padding: "0 5px",
                    color: "#bfbfbf",
                }, className: "list-item-menu-button" }) })));
    };
    return (_jsxs(Card, __assign({ title: title, extra: _jsx(Space, { children: allButtons.map(function (button, index) {
                return React.cloneElement(button, { key: index });
            }) }), className: "list-panel", loading: loading, style: {
            height: typeof height === "number" ? "".concat(height, "px") : height,
        }, styles: {
            body: {
                padding: showSearch ? "0 16px" : "0 16px",
                display: "flex",
                flexDirection: "column",
                height: "100%",
                overflow: "hidden",
                paddingTop: 16,
                rowGap: 16, // 使用 gap 控制子元素之间的垂直间距，避免子元素 margin 影响剩余高度
            },
        } }, { children: [showSearch && (_jsx(Search, { placeholder: "\u641C\u7D22...", allowClear: true, onChange: function (e) { return handleSearch(e.target.value); }, style: {} })), _jsx("div", __assign({ style: {
                    flex: 1,
                    minHeight: 0,
                    overflow: "auto",
                } }, { children: filteredListData.length > 0 ? (_jsx(List, { className: "position-list", dataSource: filteredListData, renderItem: function (item) { return (_jsx(List.Item, __assign({ onClick: function () { return onSelect && onSelect(item); }, style: {
                            cursor: onSelect ? "pointer" : "default",
                            backgroundColor: selectedId === item.id ? "#f0f7ff" : "transparent",
                            padding: "8px",
                            borderRadius: "4px",
                            transition: "background-color 0.3s",
                        }, className: "list-item" }, { children: _jsxs("div", __assign({ style: {
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                                alignItems: "center",
                            } }, { children: [_jsxs("div", __assign({ style: {
                                        display: "flex",
                                        alignItems: "center",
                                        fontWeight: selectedId === item.id ? 500 : 400,
                                    } }, { children: [_jsx("span", __assign({ style: { marginRight: "8px" } }, { children: item.leftContent })), item.rightContent && (_jsx("div", __assign({ style: {
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                backgroundColor: "rgba(24, 144, 255, 0.7)",
                                                color: "white",
                                                borderRadius: "50%",
                                                width: "16px",
                                                height: "16px",
                                                fontSize: "10px",
                                                fontWeight: "normal",
                                                lineHeight: "20px",
                                                textAlign: "center",
                                            } }, { children: extractNumberFromContent(item.rightContent) })))] })), onMenuClick && menuItems.length > 0 && renderItemMenu(item)] })) }), item.id)); } })) : (_jsx(Empty, { description: "\u6682\u65E0\u6570\u636E" })) }))] })));
};
export default GenericPanelList;
